/** THIS CONTAINS ALL WORDS THAT ARE CONSIDERED STATICALLY PRESENT IN THE APP, DYNAMICALLY ADDED CONTENTS WILL NOT BE HANDLED **/
export default {
  'app.loading': 'Finishing up some processes...',
  'app.logout': 'Logging out...',

  //NavBar
  'nav.profile': 'Profile',
  'nav.logout': 'Logout',
  'nav.home': 'HOME',
  'nav.classrooms': 'CLASSROOMS',
  'nav.educators': 'EDUCATORS',
  'nav.about': 'ABOUT US',
  'nav.sign-in': 'SIGN IN',
  'nav.sign-up': 'SIGN UP',
  'nav.apply': 'MAG-APPLY BILANG GURO',

  //Footer
  'footer.languages-available': 'Mga Wika',
  'footer.about-intereact': 'About InteReact',
  'footer.legal-terms': 'Legal Terms',
  'footer.survey': 'Take the survey',
  'footer.contact': 'Have a question?',
  'footer.about-content':
    'InteReact is a free language learning service that caters to all kinds of learners. This application aims to serve as an exclusive portal for language learning and teaching through the use of digital classrooms. The project is created in fulfillment of the requirements for the Degree of Bachelor of Science in Computer Science.',
  'footer.about-read': 'Read more',
  'footer.terms': 'Terms and Conditions',
  'footer.privacy': 'Privacy Policy',
  'footer.cookies': 'Cookie Policy',
  'footer.survey-explanation':
    'This survey covers areas like convenience level, satisfaction rate and variation from other language learning apps. However, the efficiency of this language learning setting in terms of how much knowledge a student learns in some time will not be covered.',
  'footer.answer-survey': 'Answer survey',

  //How To Apply
  'how-to-become-educator': 'How can I become an educator of InteReact?',
  'how-to-professional': 'Professional Teaching Profile',
  'how-to-native': 'Native Speakers Who Like To Teach',
  'how-to-bitriprof': 'Bilingual or Multilingual Proficiency',
  'how-to-user-type': 'Register as Educator',
  'how-to-user-type-desc':
    'Signing up as an educator is required for the administrators to successfully verify your account as permitted to teach.',
  'how-to-professional-desc':
    'The fastest way to be accepted as an educator and start creating your first classroom is to provide a written document showing your training and experience as an educator. ' +
    'A person who is certified to teach or is already teaching a language professionally may qualify for a professional teaching profile on InteReact.',
  'how-to-native-desc':
    'Native speakers who want to teach their language can also apply for verification. You can either send a video showing at least that you are proficient enough to your second language.' +
    'Sending a personal e-mail stating your purpose to join is also possible. In InteReact, we are open to those language lovers who want to share their linguistic skills to everyone for free.',
  'how-to-bitriprof-desc':
    'Proving that you can speak at least 2 languages is ideal to have your application verified.',
  'how-to-send-email': 'Send an e-mail to InteReact',
  'how-to-send-email-desc': 'Send an e-mail to InteReact',

  //HomeGen
  'homegen.headings': 'Fluency Through Language Exposure',
  'homegen.main-intro':
    'Language always carries meaning and references beyond itself. The meanings of a particular ' +
    'language represent the culture of a particular social group. In InteReact, we believe that language learning is ' +
    'not solely to learn and memorize complex grammar rules and hard word spellings but also opens up the door to comprehend the behavior ' +
    'of the society and its cultural customs.',
  'homegen.why-learn-a-language':
    'Through the Communicative Language Teaching approach deployed by the use of online classrooms, you can interact with other students and your educator while learning the language. ' +
    'Other pedagogical approaches to language learning can be utilized too depending on the educator, however, regardless of the approach to teaching, studying a language in InteReact would be fun because of its interactive ecosystem. ' +
    'Each classroom can only cater to at least 50 students, thus, limiting the environment to a small ecosystem.',
  'homegen.headings-button': 'Alamin pa',
  'homegen.middle-block-headings': 'Matuto ng iba pang mga wika',
  'homegen.middle-block-icon-1': 'Matuto ng ibang wika',
  'homegen.middle-block-icon-2': 'Talk to our educators',
  'homegen.middle-block-icon-3': 'Talk in the classroom',
  'homegen.features-text': 'Features',
  'homegen.features-title-1': 'All Free',
  'homegen.features-title-2': 'Dedicated Classroom',
  'homegen.features-title-3': 'Proof of Completion',
  'homegen.features-title-4': 'Live Lecture',
  'homegen.features-title-5': 'Interactive',
  'homegen.featues-title-desc-1':
    'No payment wall hinders your desire to learn a language whether be it a hobby or professional reasons. Educators ' +
    'are free to teach any time they like or during their free time. Many thanks to those who would share some or even a little of their time to teach a language for free.',
  'homegen.featues-title-desc-2':
    'Each classroom caters to up to 50 students and 1 educator. Educators can even start the classroom even with only 5 students enrolled, thus, a small yet interactive ecosystem for all.',
  'homegen.featues-title-desc-3':
    'A digital certificate of completion will also be given after the educator marks the class as finished. A link will be given which will you can share to everyone!',
  'homegen.featues-title-desc-4':
    'Educators can host a live lecture for free, yet it could be limited due to issue on resources. Regardless, learning would be much more fun in real time!',
  'homegen.featues-title-desc-5':
    'Classrooms have a Lecture, Assignment, Chat, Stream-like and Calendar Pages built-in to facilitate a continuous communication. Chatting will still be possible even with finished classes!',

  //ClassroomsGen
  'classroomsgen.headings': 'Mga Classroom',
  'classroomsgen.cbox-educ-text': 'Guro',
  'classroomsgen.cbox-lang-spoken-text': 'Wikang Sinasalita',
  'classroomsgen.cbox-btn-text': 'Sumali na',
  'classroomsgen.cbox-helper-icon-msg':
    'Educators cannot join classrooms and students can only join up to 1 classroom.',
  'classroomsgen.students-enrolled': 'Naka-enrol na Estudyante',
  'classroomsgen.students-noenrolled': 'Wala pang edtudyanteng naka-enrol',
  'classroomsgen.students-enroll': 'Mag-enrol',
  'classroomsgen.joining': 'Enrolling in the class...',
  'classroom.error-full': 'Classroom Full',
  'classroom.error-email-unverified':
    'Ang e-mail address na nakalink sa iyong account ay hindi verified. Magpadala ng verification link.',
  'classroom.error-full-desc': 'Limampung estudyante na ang nakapag-enrol sa klase.',
  'classroom.error-active': 'May Classroom Nang Aktibo',
  'classroom.error-active-desc':
    'Isang classroom lamang ang pwedeng i-enrol. Kung pwede pa, maaari mong i-unenrol ang kasalukuyang klase kung saan ka naka-enrol sa pagpunta sa Classroom page. Maaari ka pa ring makapag-enrol matapos mai-set sa finished ang kasalukuyan mong klase.',
  'classroom.success-join': 'Successfully Joined',
  'classroom.success-join-desc':
    'Congratulations! Nakapag-enrol ka sa classroom. Maari mo nang i-refresh ang app.',
  'classroom.go-to-classroom-page': 'Pumunta sa Classroom',

  //Educators
  'educators.filter-by-nationality': 'Nasyonalidad',
  'educators.filter-by-language': 'Nagsasalita rin ng',
  'educators.search-by-name': 'Hanapin ang mga guro sa kanilang pangalan',
  'educators.apply-filter': 'I-apply ang filter',
  'educators.educators-found-text': 'na mga guro ang nahanap',
  'educators.educators-found-text-singular': 'guro ang nahanap',
  'educators.educators-no-rating': 'Walang rating',
  'educators.educators-speaks': 'Nagsasalita ng',
  'educators.educators-description': 'Paglalarawan',
  'educators.educators-description-empty': 'Walang paglalarawan na binigay',

  //SignIn
  'signin.welcome-msg': 'Maligayang pagbabalik! Mag-sign in muli sa iyong account.',
  'signin.email-field': 'E-mail',
  'signin.password-field': 'Password',
  'signin.remember-field': 'Tandaan ako',
  'signin.forgot-field': 'Nakalimutan ang password',
  'signin.new-to-field': 'Bago sa InteReact? Gumawa ng account.',
  'signin.terms-and-privacy': 'Mga tuntunin ng Paggamit. Patakaran sa Privacy.',
  'signin.button': 'Mag-sign In',
  'signin.modal-signing': 'Nagsisign-in...',
  'signin.error-email-existence': 'Ang e-mail ay hindi nakalink sa anumang account.',
  'signin.error-unmatch': 'Ang account na iyong inaaccess ay naka-ban.',

  //Sign Up
  'signup.bg-headings-1': 'Learn and Test Your Linguistic Skills Today',
  'signup.bg-headings-2': 'Language Exposure | Fluency | Communicate',
  'signup.form-student': 'Mag-sign Up Bilang Estudyante',
  'signup.form-educator': 'Mag-sign Up Bilang Guro',
  'signup.form-complete-msg': 'Kumpletuhin upang magawa ang iyong account.',
  'signup.form-first-name': 'Pangalan',
  'signup.form-last-name': 'Apelyido',
  'signup.form-username': 'Username',
  'signup.form-gender': 'Kasarian',
  'signup.form-gender-male': 'Lalaki',
  'signup.form-gender-female': 'Babae',
  'signup.form-email': 'Email',
  'signup.form-password': 'Password',
  'signup.form-languages-spoken': 'Wikang Sinasalita',
  'signup.form-language-already-chosen': 'Napili mo na ang wikang iyan.',
  'signup.form-language-not-supported': 'Ang wikang napili ay hindi suportado.',
  'signup.form-nationality': 'Nasyonalidad',
  'signup.form-agree-terms': 'Sumasang-ayon ako sa mga tuntunin at kundisyon',
  'signup.form-button': 'Mag-sign Up',
  'signup.form-ahaa-signin': 'Mayroon nang account? Mag-sign in.',
  'signup.modal-signing': 'Ginagawa ang account...',

  //ForgotPassword
  'forgotpassword.headings': 'Password Reset',
  'forgotpassword.reenter': 'Re-enter Email',
  'forgotpassword.send': 'Magpadala ng Link',
  'forgotpassword.invalid-email': 'Magbigay ng valid na email',
  'forgotpassword.unmatch': 'Hindi nagtutugma ang emails.',
  'forgotpassword.match-valid': 'Ang dalawang emails ay magkatugma.',
  'forgotpassword.unexisting': 'Walang email na ganiyan ang nakita.',
  'forgotpassword.sent': 'Naipadala ang email.',
  'forgotpassword.emailheadings': 'Email Verification',
  'forgotpassword.unverified': 'Email Unverified',

  //User Inputs Errors
  'input-errors-required': 'Ang field na ito ay kailangan.',
  'input-errors-first-name-errlength':
    'Ang pangalan ay dapat na 2 hanggang 32 na karakter lamang.',
  'input-errors-last-name-errlength':
    'Ang apelyido ay dapat na 2 hanggang 32 na karakter lamang.',
  'input-errors-email-invalid': 'Ang e-mail na ito ay invalid.',
  'input-errors-password-errlength':
    'Ang password ay dapat na hindi bababa sa 6 na karakter.',
  'input-error-username-empty': 'Ang username ay hindi dapat blanko.',
  'input-error-username-alphanumeric':
    'Ang username ay naglalaman ng hindi valid na input.',
  'input-error-username-allnumbers': 'Ang username ay dapat na mayroong mga letra rin.',
  'input-error-full-name-empty': 'Ang full name ay hindi dapat blanko.',
  'input-error-full-name-errlength':
    'Ang full name ay dapat na 4 hanggang 64 na mga karakter lamang.',
  'input-error-description-empty': 'Ang paglalarawan ay hindi dapat blanko.',
  'input-error-description-errlength':
    'Ang paglalarawan ay dapat na maayos, bagkus, naniniwala kami na ito dapat ay magkaroon ng 32 hanggang 1024 na mga karakter.',
  'input-error-languages-empty': 'Ang mga wikang sinasalita ay hindi dapat blanko.',
  'input-error-cname-errlength':
    'Ang pangalan ng classroom ay dapat na 4 hanggang 64 na karakter lamang.',
  'profile.classroom-created': 'Ang classroom ay maayos na nagawa!',
  'profile.classroom-failed':
    'Isang active classroom lamang ang pwede bawat guro. Kung gusto mong gumawa ng bago, maaari mong i-set ang kasalukuyang active sa finished.',
  'profile.classroom-educator-unverified':
    'Kailangan ng beripakasyon ng admin bago ka makagawa ng classroom. Tingnan ang mga kwalipikasyon kung paano mag-apply bilang guro.',
  'profile.classroom-see-how': 'Tingnan kung paano',

  //Profile
  'profile.add-classroom': 'Magdagdag ng Classroom',
  'profile.edit-profile': 'I-edit ang Profile',
  'profile.join-classroom': 'Sumali sa Klase',
  'profile.classrooms-list': 'Classrooms',
  'profile.helper-modal-classrooms-what': 'Ano ang mga imaheng ito?',
  'profile.helper-modal-classrooms-done':
    'Ipapakita ng imaheng ito ang mga klaseng minarkahang tapos na.',
  'profile.helper-modal-classrooms-current':
    'Ipapakita ng imaheng ito ang kasalukuyang aktibong klase.',
  'profile.by-educator': 'kay',
  'profile.description': 'Paglalarawan',
  'profile.send-message': 'Magpadala ng mensahe',
  'profile.full-name': 'Buong Pangalan',
  'profile.position': 'Posisyon',
  'profile.occupation': 'Trabaho',
  'profile.birthday': 'Kaarawan',
  'profile.gender': 'Kasarian',
  'profile.username': 'Username',
  'profile.change-avatar': 'Magbago ng Avatar',
  'profile.size-limit': 'Hanggang 10 MB',
  'profile.upload': 'I-upload',
  'profile.languages-spoken': 'Wikang Sinasalita',
  'profile.nationality': 'Nasyonalidad',
  'profile.modal-headings': 'Bagong Classroom',
  'profile.modal-cname': 'Pangalan ng Classroom',
  'profile.modal-cstarts': 'Simula ng Klase',
  'profile.modal-tlanguage': 'Wikang Ituturo',
  'profile.modal-days-from-sing': 'araw mula ngayon',
  'profile.modal-days-from-plu': 'araw mula ngayon',
  'profile.modal-input-placeholder': 'Isulat ang pangalan ng classroom dito.',
  'profile.modal-button-cancel': 'Umalis',
  'profile.modal-button-create': 'Gumawa',
  'profile.edit-add-language': 'Magdagdag dito ng wika.',
  'profile.edit-modal-changes': 'Ang mga sumusunod na field ay mababago.',
  'profile.edit-modal-proceed': 'Magpatuloy',
  'profile.edit-modal-loader-editing': 'Ini-edit ang profile...',
  'profile.edit-modal-success': 'Ang profile ay nabago nang maayos.',
  'profile.edit-modal-failure': 'Nag-fail ang pagbabago ng profile.',

  // General Position Localized
  'profile.M-educator': 'Guro',
  'profile.F-educator': 'Guro',
  'profile.M-student': 'Estudyante',
  'profile.F-student': 'Estudyante',

  //Classroom
  'classroom.sidebar-home': 'Home',
  'classroom.sidebar-lecture': 'Lecture Hub',
  'classroom.sidebar-assignment': 'Assignment Hub',
  'classroom.sidebar-live-lecture': 'Live Lecture',
  'classroom.sidebar-chat-room': 'Classroom Chat Room',
  'classroom.sidebar-calendar': 'Calendar',
  'classroom.sidebar-help-center': 'Help Center',
  'classroom.sidebar-settings': 'Settings',
  'classroom.not-yet-started': 'Ang natitirang oras bago magsimula ang klase',
  'classroom.educator-guide':
    "Bilang guro, maari mong simulan ang klase kahit 'di pa tapos ang oras kung: ",
  'classroom.educator-list-1': 'Higit sa 5 estudyante na ang nakapagenrol sa klase',
  'classroom.students-enrolled': 'Bilang ng estudyanteng kasalukuyang naka-enrol',
  'classroom.go-back': 'Bumalik sa Home',
  'classroom.start-classroom': 'Simulan ang Klase',
  'classroom.unenroll': 'Unenroll',
  'classroom.delete': 'I-delete ang Klase',
  'classroom.warning': 'Babala',
  'classroom.warning-unenroll':
    'Unenrollment can only be done at this time. When the class starts, unenrollment will no longer be possible.',
  'classroom.warning-deletion':
    'Classroom deletion can only be done at this time. When the class starts, deletion will no longer be possible.',

  //Classroom Lecture
  'classroom.lecture-modal-headings': 'Magdagdag ng Aralin',
  'classroom.lecture-modal-files': 'Mag-attach ng files (Opsyonal)',
  'classroom.lecture-modal-time':
    'Magtakda ng oras kung kailan maipapaskil ang araling ito. (Opsyonal)',
  'classroom.lecture-modal-savebtn': 'I-save',
  'classroom.lecture-modal-cancelbtn': 'Umalis',
  'classroom.lecture-modal-deletebtn': 'Tanggalin',
  'classroom.lecture-modal-title': 'Pamagat',
  'classroom.lecture-modal-description': 'Paglalarawan',
  'classroom.lecture-modal-title-desc': 'Dito ilagay ang pamagat ng aralin',
  'classroom.lecture-modal-title-length': 'Haba ng Pamagat',
  'classroom.lecture-modal-description-desc': 'Dito ilagay ang paglalarawan sa aralin',
  'classroom.lecture-modal-description-length': 'Haba ng Paglalarawan',
  'classroom.lecture-modal-file-audio': 'Magdagdag ng audio file',
  'classroom.lecture-modal-file-attachment': 'Magdagdag ng document file',
  'classroom.lecture-modal-file-image': 'Magdagdag ng image file',
  'classroom.lecture-modal-file-video': 'Magdagdag ng video file',
  'classroom.lecture-modal-uploaded-msg': 'File na naka-upload',
  'classroom.lecture-modal-uploaded-empty': 'Wala pang file na naka-upload',
  'classroom.lecture-modal-creating-lecture': 'Ang aralin ay kasalukuyang ginagawa.',
  'classroom.lecture-modal-creating-interrupt': 'Ihinto ang Pag-upload',
  'classroom.lecture-modal-date-hours': 'Oras',
  'classroom.lecture-modal-date-minutes': 'Minuto',
  'classroom.lecture-modal-date-set-valid': 'Ang petsa ay valid.',
  'classroom.lecture-modal-date-set-invalid': 'Bakit ko ito nakikita?',
  'classroom.lecture-modal-date-invalid-desc1':
    'Ang napiling petsa ay hindi dapat lagpas na sa kasalukuyang oras. Ang oras na napili ay dapat na hihigit pa sa 10 minuto.',
  'classroom.lecture-modal-date-invalid-desc2':
    'Kung inaasahan mong mai-uupload ito sa loob ng 10 minuto, ang eksaktong oras ng pag-upload ay oras ng pag-upload + 10 minuto.',
  'classroom.lecture-fetching': 'Kinakalap ang mga aralin',
  'classroom.single-lecture-back': 'Bumalik',
  'classroom.single-lecture-posted': 'Naipost na ang aralin',
  'classroom.single-lecture-audio-icon': 'I-click ang play upang makinig sa audio.',
  'classroom.single-lecture-document-icon':
    'Mag-click dito upang idownload ang dokumento.',
  'classroom.single-lecture-nofile-icon':
    'Walang file ang naka-upload para sa araling ito.',
  'classroom.single-lecture-nocomment-msg': 'Wala pang komento sa araling ito',
  'classroom.single-lecture-comment-textarea-placeholder': 'Magpadala ng komento rito',
  'classroom.single-lecture-comment-loading': 'Kinakalap ang mga komento',
  'classroom.single-lecture-comment-errormsg':
    'Ang komento ay dapat 1 hanggang 256 na mga karakter.',
  'classroom.single-lecture-comment-sending-errormsg': 'Ang mensahe ay hindi naipadala.',
  'classroom.single-lecture-comment-sending-started': 'Ipinapadala ang mensahe',
  'classroom.single-lecture-comment-has-said-at': 'ay nagsabi sa oras na',

  //Classroom Assignment
  'classroom.assignment-type-text': 'Uri',
  'classroom.assignment-due-date': 'Itinakdang Pasahan',
  'classroom.assignment-type-helper-redirect': 'Alamin kung ano ito',
  'classroom.assignment-view-button': 'Tignan',
  'classroom.assignment-modal-choose': 'Pumili ng uri ng gawain',
  'classroom.assignment-modal-interactive-type': 'Interaktibo',
  'classroom.assignment-modal-document-type': 'Dokumento',
  'classroom.assignment-modal-exam-type': 'Pagsusulit',
  'classroom.assignment-modal-helper-document-headings':
    'Sa dokumentong uri, makikita ang mga sumusunod:',
  'classroom.assignment-modal-helper-document-list1':
    'Maaring makapag-upload ng file bilang attachment',
  'classroom.assignment-modal-helper-document-list2':
    'Maaari ring makapag-upload ng file ang mga estudyante kapag ipinasa na nila ang kanilang gawain',
  'classroom.assignment-modal-helper-document-list3':
    'Bilang isa sa mga limitasyon ng app, isang file lamang muna ang maaring i-upload',
  'classroom.assignment-modal-helper-interactive-headings':
    'Sa interaktibong uri, makikita ang mga sumusunod:',
  'classroom.assignment-modal-helper-interactive-list1':
    'Walang file na kailangang i-upload',
  'classroom.assignment-modal-helper-interactive-list2':
    'Pindutin ang button sa ibaba upang makita ang halimbawa ng interaktibong uri',
  'classroom.assignment-modal-helper-interactive-button-demo': 'Subukan ang demo',
  'classroom.assignment-modal-helper-exam-headings':
    'Ang pagsusulit ay espesyal na uri ng gawain. Makikita ang mga sumusunod sa ganitong uri:',
  'classroom.assignment-modal-helper-exam-list1':
    'Dobleng puntos ang makukuha sa markang makukuha',
  'classroom.assignment-modal-helper-exam-list2':
    'Matapos piliin ang mode na pagsusulit, maari kang pumili kung dokumentong-uri o interaktibong-uri ang magiging mode ng exam',
  'classroom.assignment-modal-demo-running-only': 'Ito ay nasa demo mode lamang.',
  'classroom.assignment-modal-demo-tips': 'Tips',
  'classroom.assignment-modal-demo-can-add-tips':
    'Maaari kang magdagdag ng tips bilang karagdagang kaalaman.',
  'classroom.assignment-modal-demo-can-add-timer': 'Maaari ka ring magdagdag ng timer.',
  'classroom.assignment-modal-demo-can-add-button': 'Magpatuloy',
  'classroom.assignment-modal-demo-press-enter':
    'I-click ang enter para i-check ang iyong sagot.',
  'classroom.assignment-interactive-choices-instructions':
    'Piliin ang titik ng tamang sagot.',
  'classroom.assignment-interactive-fill-instructions':
    'Ilagay ang tamang sagot sa patlang.',
  'classroom.assignment-interactive-multiplefill-instructions':
    'Ilagay ang mga sumusunod na sagot sa mga patlang.',
  'classroom.assignment-interactive-demo-close': 'Isara ang demo',
  'classroom.assignment-modal-headings': 'Magdagdag ng Gawain',
  'classroom.assignment-modal-title-desc': 'Ilagay ang pamagat ng gawain dito',
  'classroom.assignment-modal-description-desc':
    'Ilagay ang karagdagang impormasyon ng gawain dito',
  'classroom.assignment-modal-time':
    'Magtakda ng oras kung kailan maipo-post ang gawain (Opsyonal)',
  'classroom.assignment-modal-submission-time': 'Magtakda ng oras ng pasahan (Kailangan)',
  'classroom.assignment-student-uploading-file':
    'Ang iyong gawain ay kasalukuyang iniu-upload...',
  'classroom.assignment-student-uploading-onleave':
    'Mawawala ang upload kapag umalis ka sa page na ito.',
  'classroom.assignment-student-uploading-success': 'Naiupload na ang iyong gawain.',
  'classroom.assignment-student-uploading-failed':
    'Hindi naiupload ang gawain. Subukan muli.',

  //Classroom ChatRoom
  'chatroom.search-placeholder': 'Hanapin ang pangalan ng guro o kaklase rito...',
  'chatroom.send-placeholder': 'Ilagay ang mensahe rito...',
  'chatroom.send-msg-count': 'Bilang ng Mensahe',
  'chatroom.main-chat-title': 'General Chat Room',
  'chatroom.main-chat-label': 'Lahat',
  'chatroom.client-preventive-msg':
    'Ang nakaraang ipinadalang mensahe ay kasalukuyan pa ring ipinapadala. Hindi muna maaring makapagpadala.',
  'chatroom.client-message-not-sent': 'Ang mensahe ay hindi naipadala.',
  'classroom.lecture-modal-creating-assignment': 'Ang gawain ay kasalukuyang ginagawa.',
  'classroom.assignment-fetching': 'Kinakalap ang mga gawain',
  'classroom.single-assignment-posted': 'Ipinost ang gawain',
  'classroom.single-assignment-back': 'Bumalik sa dati',
  'classroom.single-assignment-comment-loading': 'Kinakalap ang mga komento',
  'classroom.single-assignment-nofile-icon':
    'Walang file ang naka-upload para sa gawaing ito.',
  'classroom.single-assignment-nosubtime': 'Walang oras na binigay',
  'classroom.assignment-submissions-fetching':
    'Kinakalap ang mga gawain ng mga estudyante...',
  'classroom.assignment-submissions-error':
    'Nagka-error sa pagkuha ng gawain ng mga estudyante.',
  'classroom.assignment-navar-general': 'General',
  'classroom.assignment-navar-submissions': 'Mga Ipinasa',
  'classroom.assignment-submissions-empty': 'Wala pang mga pinapasang gawain.',
  'classroom.assignment-submissions-student-view': 'Tingnan ang akin gawa',
  'classroom.assignment-student-submit-a-file': 'Mag-submit ng file',
  'classroom.assignment-student-empty-submission':
    'Mukhang hindi ka pa nakakapagsumite ng gawain.',
  'classroom.assignment-student-submit': 'Isumite ang gawain',
  'classroom.assignment-student-see-work': 'Tingnan ang aking isinumite',
  'classroom.assignment-student-private-comment': 'Magpadala ng pribadong komento',
  'classroom.assignment-student-submission-status-text': 'Status',
  'classroom.assignment-student-submission-status-ontime': 'Turned in',
  'classroom.assignment-student-submission-status-late': 'Turned in late',
  'classroom.assignment-student-submission-status-missing': 'Task missing',
  'classroom.assignment-submitted-on': 'Isinumite',
  'classroom.assignment-my-work': 'Aking Gawa',
  'classroom.assignment-delete-info':
    'Maaari mong isumite ulit ang iyong gawa sa pamamagitan nang pagdelete sa gawaing ito. Isara ang kahon na ito, at mag-add muli ng file.',
  'classroom.assignment-delete-button': 'I-delete',
  'classroom.assignment-assurance':
    'Sigurado ka bang gusto mong i-delete ang gawain? Mababago muli ang oras kung kailan mo isinumite ang gawain.',
  'classroom.deleting-started': 'Dinedelete ang gawain...',
  'classroom.deleting-success': 'Ang iyong gawain ay nadelete na.',
  'classroom.deleting-failed': 'May error sa pagdelete ng gawain. Subukan muli.',
  'classroom.work-of': 'Gawa ni',
  'classroom.assignment-givemark-info':
    'Maaari mo pa ring mabago ang grade na binigay mo sa estudyante.',
  'classroom.assignment-givemark': 'Bigyan ng marka',
  'classroom.assignment-score': 'Marka',
  'classroom.assignment-total': 'Kabuuan',

  //Classroom Calendar
  'classroom.calendar-modal-time':
    'Pumili ng oras kung kailan maipo-post ang event (Kaialangan)',
  'classroom.calendar-modal-input-change':
    'Isulat ang pangalan ng event sa baba (Kailangan)',
  'classroom.calendar-modal-input-error-name':
    'Siguraduhin na ang pangalan ng event ay may 3 hanggang 128 na mga karakter.',
  'classroom.calendar-modal-input-error-time':
    'Siguraduhin na ang napiling oras ay valid.',
  'classroom.calendar-no-events': 'Wala pang event na naipo-post para sa buwan ng ',
  'classroom.calendar-event-modal-view-event': 'Pangalan ng Event',
  'classroom.calendar-event-modal-view-time': 'Ang event ay magaganap sa ',
  'classroom.calendar-event-modal-edit-event': 'Baguhin ang event',
  'classroom.calendar-event-modal-edit-failed':
    'Ang pag-edit ng event ay hindi gumana. Subukan muli.',
  'classroom.calendar-event-modal-creating': 'Ang event ay kasalukuyang isinisave.',
  'classroom.calendar-event-modal-editing': 'Ang event ay kasalukuyang inii-edit.',
  'classroom.calendar-event-modal-deleting': 'Ang event ay kasalukuyang tinatanggal.',

  //Errors
  'add-modal-error-empty': 'Ang field na ito ay kailangan.',
  'add-modal-title-error-short': 'Ang pamagat ay masyadong maikli.',
  'add-modal-title-error-exceeded': 'Ang pamagat ay masyadong mahaba.',
  'add-modal-description-error-short': 'Ang paglalarawan ay masyadong maikli.',
  'add-modal-description-error-exceeded': 'Ang paglalarawan ay masyadong mahaba.',
  'add-modal-file-size-exceeded': 'Ang laman ng file ay hindi dapat tumaas pa sa 100 MB.',
  'add-modal-file-size-valid': 'Ang laman ng file ay valid.',
};
